<template>
<div>
<div v-for="(item, index) in items" :key="index">
  <div>{{item.auftragStatus}}</div>
  <AuftragOverview ref="AuftragOverview" :auftrag="item" @refresh-list="refresh"/>
</div>
</div>
</template>
<script>
import AuftragOverview from '@/components/partials/AuftragOverview'
import afunc from '@/functions.js'

export default {
  name: 'statusList',
  components: {AuftragOverview},
  data () {
    return {
      loading: false,
      items: [
        {
          'auftragStatus': 'Angelegt',
          'format': {'name': 'Nachrichten & Sport'}
        },
        {
          'auftragStatus': 'NeueAnfrage',
          'format': {'name': 'Nachrichten & Sport'}
        },
        {
          'auftragStatus': 'AnfrageAbgelehnt',
          'format': {'name': 'Nachrichten & Sport'}
        },
        {
          'auftragStatus': 'InBearbeitung',
          'kundeFormular': 'Ich bin Disponent oder habe nicht reagiert',
          'format': {'name': 'Nachrichten & Sport'}
        },
        {
          'auftragStatus': 'InBearbeitung',
          'kundeFormular': 'Ich habe mich beworben',
          '__myAngebot': {'auftragAngebotStatus': 'Angenommen'},
          'format': {'name': 'Nachrichten & Sport'}
        },
        {
          'auftragStatus': 'Bestaetigt',
          'kundeFormular': 'Ich habe es bekommen',
          'cutterId': this.$store.state.auth.user.id,
          '__myAngebot': {'auftragAngebotStatus': 'Angenommen'},
          'format': {'name': 'Nachrichten & Sport'}
        },
        {
          'auftragStatus': 'Bestaetigt',
          'kundeFormular': 'Ich habe es *nicht* bekommen',
          'cutterId': 0,
          '__myAngebot': {'auftragAngebotStatus': 'Angenommen'},
          'format': {'name': 'Nachrichten & Sport'}
        },
        {
          'auftragStatus': 'Bestaetigt',
          'kundeFormular': 'Ich bin Disponent',
          'format': {'name': 'Nachrichten & Sport'}
        },
        {
          'auftragStatus': 'Erledigt',
          'format': {'name': 'Nachrichten & Sport'}
        },
        {
          'auftragStatus': 'Abgeschlossen',
          'format': {'name': 'Nachrichten & Sport'}
        },
        {
          'auftragStatus': 'Storniert',
          'format': {'name': 'Nachrichten & Sport'}
        },
        {
          'auftragStatus': 'Standby',
          'format': {'name': 'Nachrichten & Sport'}
        }
      ]
    }
  },
  mounted () {
    this.refresh()
  },
  methods: {
    async showFunctions () {
      return afunc.showInternalFunctions()
    },
    async refresh () {
    }
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/main/vue/components/internal/StatusList.vue